export const FloridaZipCodes = Array.from({ length: 99950 }, (_, i) =>
  (i + 1).toString().padStart(5, '0')
);